module.exports = __webpack_public_path__ + "img/face_kenji.3606e191.png";